import { Result } from 'antd'
// import { useRouteError } from 'react-router-dom'
// import { useEffect } from 'react'
// import { captureException } from '@sentry/react'
import { Button, paths } from '@/shared'

export const ErrorBoundary = () => {
  // const error = useRouteError()

  // useEffect(() => {
  //   captureException('Error boundary', {
  //     extra: {
  //       error,
  //     },
  //   })
  // }, [error])

  return (
    <Result
      status='500'
      subTitle='Sorry, something went wrong.'
      extra={
        <a href={paths.main()}>
          <Button type='primary'>Back Home</Button>
        </a>
      }
    />
  )
}
